import { Breadcrumb } from "@components/anti"
import { useScrollAnim } from "@components/hooks/hooks"
import { useRouter } from "next/router"

export default function ProjectGalleryDetailHeader({ data }) {
  const { locale } = useRouter()
  const [trigger, anim] = useScrollAnim()
  return (
    <section className="sc-project-gallery-detail-header py-3" ref={trigger}>
      <div className="container">
        <Breadcrumb
          linkData={[
            { text: "Home", url: "/" },
            {
              text:
                locale === "en" ? "Project Gallery & Events" : "Proyek & Event",
              url: "/project-gallery",
            },
            {
              text: data?.category?.title,
              url: `/project-gallery/${data?.category?.slug}-${data?.category?.id}`,
            },
            { text: data?.title },
          ]}
          className={anim(1)}
        />
        <h1 className={`title ${anim(2)}`}>{data?.title}</h1>
        <p className={`description ${anim(3)}`}>{data?.description}</p>
        <div className="information-row row">
          <div className={`info-item  ${anim(4)}`}>
            <span className="label">
              {locale === "en"
                ? "Architect/Interior Designer"
                : "Arsitek/Desainer Interior"}
            </span>
            <span className="value">{data?.architect || "-"}</span>
          </div>
          <div className={`info-item  ${anim(5)}`}>
            <span className="label">Photographer</span>
            <span className="value">{data?.photographer || "-"}</span>
          </div>
          <div className={`info-item location ${anim(6)}`}>
            <span className="label">Location</span>
            <span className="value">{data?.location || "-"}</span>
          </div>
          <div className={`info-item other-information ${anim(7)}`}>
            <span className="label">Other Information</span>
            <span className="value">{data?.other_information || "-"}</span>
          </div>
        </div>
      </div>
    </section>
  )
}
